import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useLanguageSwitch } from '@/hooks/useLanguage';

export default function MadeForBangladesh() {
  const { t } = useTranslation();
  const { currentLang } = useLanguageSwitch();
  const prefix = currentLang === 'ko' ? '/ko' : currentLang === 'bn' ? '/bn' : '';

  const concerns = [
    { icon: 'ri-sun-line', title: t('brandStory.madeFor.concern1.title'), desc: t('brandStory.madeFor.concern1.desc') },
    { icon: 'ri-water-percent-line', title: t('brandStory.madeFor.concern2.title'), desc: t('brandStory.madeFor.concern2.desc') },
    { icon: 'ri-contrast-drop-line', title: t('brandStory.madeFor.concern3.title'), desc: t('brandStory.madeFor.concern3.desc') },
    { icon: 'ri-hand-heart-line', title: t('brandStory.madeFor.concern4.title'), desc: t('brandStory.madeFor.concern4.desc') },
  ];

  return (
    <section className="w-full bg-[#2A2A2A] py-20 md:py-28 px-6 md:px-12 lg:px-20">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Left: Text */}
          <div className="flex flex-col gap-6">
            <div className="flex items-center gap-3">
              <div className="w-8 h-px bg-[#7B1113]" />
              <span className="text-[11px] tracking-[0.2em] uppercase text-[#7B1113] font-medium">
                {t('brandStory.madeFor.label')}
              </span>
            </div>

            <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-bold text-white leading-[1.15]">
              {t('brandStory.madeFor.heading')}
            </h2>

            <div className="flex flex-col gap-4">
              <p className="text-sm text-white/50 font-light leading-[1.9]">
                {t('brandStory.madeFor.p1')}
              </p>
              <p className="text-sm text-white/50 font-light leading-[1.9]">
                {t('brandStory.madeFor.p2')}
              </p>
            </div>

            {/* CTA */}
            <Link
              to={prefix + '/3-step-treatment'}
              className="mt-2 px-8 py-3.5 bg-[#7B1113] text-white text-xs tracking-[0.15em] uppercase rounded-full hover:bg-[#5C0D0F] transition-colors cursor-pointer w-fit text-center"
            >
              {t('brandStory.madeFor.cta')}
            </Link>
          </div>

          {/* Right: Concern cards */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            {concerns.map((concern) => (
              <div
                key={concern.title}
                className="flex flex-col gap-3 p-6 rounded-xl bg-white/5 border border-white/10 backdrop-blur-sm"
              >
                <div className="w-10 h-10 rounded-full bg-[#7B1113]/20 flex items-center justify-center">
                  <i className={`${concern.icon} text-[#7B1113] text-lg`} />
                </div>
                <div className="flex flex-col gap-1">
                  <span className="text-sm font-medium text-white">{concern.title}</span>
                  <span className="text-xs text-white/40 font-light leading-[1.6]">{concern.desc}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}